/* External dependencies */
import { from, of } from 'rxjs';
import { catchError, debounceTime, filter, switchMap } from 'rxjs/operators';

/* Local dependencies */
import { getClient } from '../../../../../clients/client';
import { listWarehousesError, listWarehousesSuccess } from './action';
import { listWarehousesQuery } from './queries';
import {
  ListWarehousesAction,
  ListWarehousesActionTypes,
  ListWarehousesInput,
  ListWarehousesRequest,
  ListWarehousesSuccess,
} from './types';

export default function listWarehousesEpic(action$) {
  return action$.pipe(
    filter((action: ListWarehousesAction) => action.type === ListWarehousesActionTypes.LIST_WAREHOUSES),
    debounceTime(800),
    switchMap((action: ListWarehousesRequest) =>
      from(listWarehouses(action.input)).pipe(catchError((error) => of(listWarehousesError(error)))),
    ),
  );
}

export async function listWarehouses(input: ListWarehousesInput): Promise<ListWarehousesSuccess> {
  const graphQLClient = await getClient();
  const variables = { input };

  const {
    data: {
      listWarehouses: { total, warehouses },
    },
  } = await graphQLClient.query({
    query: listWarehousesQuery,
    variables,
  });

  return listWarehousesSuccess(total, warehouses);
}
